import React, { Component } from 'react';
import { connect } from 'react-redux'
import { urbumuAtradnesActions, urbumuAtradneUrbumsSelected } from '../../actions/hidrogeoActions'
import Loading from '../Loading'
import SplitterLayout from 'react-splitter-layout'
import Form from '../forms/Form'
import IzraktenisMap from '../karte/IzraktenisMap'
import { guiSet } from '../../actions/uiActions'
import BootstrapTable from 'react-bootstrap-table-next'
import { columnCfgToBootstrapTableColumn } from '../grid/Grid'
import {
  getBadgeFormatterForKodif,
  getEditIconColumn, getSelectFilterCfg
} from '../grid/ColumnHelpers'
import { ATRADNES_PAZEMES_UDENU_OBJEKTI_NOT_FOUND } from '../../constants';
import { format } from 'date-fns';
import { urbumuAtradnesPolyStyles, urbumuAtradnesUrbumiStyle, urbumuAtradnesLegend } from '../karte/urbumuAtradnesStyles';
import { aizsargjoslasVeidsDzerUdens } from '../../reducers/kodifikatorsReducers';

const getFormFieldCfgs = () => {
  return [
    { name: 'id', renderClassName: "bold" },
    { name: 'nosaukums', renderClassName: "bold" },
    {
      name: 'pazemes_udenu_objekti',
      renderer: (puo) => `${puo === ATRADNES_PAZEMES_UDENU_OBJEKTI_NOT_FOUND ? '-' : puo}`
    },
    { name: 'pazemes_udenu_veidi' },
    { name: 'merkis' },
    {
      name: 'udizm_kods',
      renderer: (kods, row) => `${kods} - ${row.udizm_nos}`
    },
    { name: 'atr_vieta' },
    { name: 'izpete' },
    { name: 'aizsargjoslas' },
    { name: 'papildus' },
    {
      name: 'prog_udens_paterins',
      renderer: (pat, row) => <>{pat} m<sup>3</sup>/dnn līdz {row.prog_udens_paterins_lidz}. gadam</>
    }
  ]
}

const editIconColumn = getEditIconColumn((row) => (
  {
    type: 'loc_urbums',
    payload: {
      id: row.id
    }
  }
)
)

const getPazemesUdenuAtradnesAizsargjoslasColumns = (aizsargjoslas) => {
  const columns = Object.keys(aizsargjoslas[0] ?? {})
    .filter(key => key !== 'id')
    .map(key => ({
      dataField: key,
      text: key,
      formatter: (val) => (val ? val.split('\r\n') : []).map((str, idx) => (
        <React.Fragment key={idx}>
          {str}
          <br />
        </React.Fragment>
      ))
    }))

  return columns.map(col => columnCfgToBootstrapTableColumn(col))
}

const getAtradnesUrbumiColumns = ({ kodif }) => {
  const columns = [editIconColumn, {
    dataField: 'id',
    text: 'Urbuma numurs LVĢMC datubāzē URBUMI',
    width: 100
  }, {
      dataField: 'urb_adrese',
      text: 'Urbuma adrese',
      width: 180
    }, {
      dataField: 'kadastra_apzimejums',
      text: 'Kadastra apzīmējums'
    }, {
      dataField: 'udens_nesejslanis',
      text: 'Ūdens nesējslānis',
      width: 240
    }, {
      dataField: 'tehniskais_stavoklis',
      text: 'Urbums stāvoklis',
      formatter: (cellContent) => {
        return getBadgeFormatterForKodif(kodif.urbumiTehniskaisStavoklis)(cellContent)
      },
      width: 120,
      filterCfg: getSelectFilterCfg(kodif.urbumiTehniskaisStavoklis)
    }]
  return columns.map(col => columnCfgToBootstrapTableColumn(col))
}

class UrbumaAtradne extends Component {

  mapPaneSizeChange = (w) => {
    this.props.guiSet('urbumu_atradne_kartina_karte_width', w);
  }

  mapPaneSizeChangeHor = (h) => {
    this.props.guiSet('urbumu_atradne_kartina_karte_height', h);
  }

  handleOnSelect = (row, isSelect) => {
    this.props.urbumuAtradneUrbumsSelected({ id: row.id, isSelect })
  }

  render() {

    const { urbumu_atradne, kodif, gui } = this.props

    const { selectedItem, selectedUrbums, pazemesUdenuAtradnesAizsargjoslas } = urbumu_atradne


    if (!selectedItem) {
      return (<Loading />)
    }

    const { akceptetie_krajumi: akceptetieKrajumi } = selectedItem

    if (!this.formFieldCfgs) {
      this.formFieldCfgs = getFormFieldCfgs({
        kodif: kodif
      })
    }

    if (!this.atradnesUrbumiColumns) {
      this.atradnesUrbumiColumns = getAtradnesUrbumiColumns({ kodif })
    }

    if (!this.pazemesUdenuAtradnesAizsargjoslasColumns) {
      this.pazemesUdenuAtradnesAizsargjoslasColumns = getPazemesUdenuAtradnesAizsargjoslasColumns(pazemesUdenuAtradnesAizsargjoslas)
    }

    const vectorLayerCfg = {
      atradnes: {
        title: 'Atradnes ģeometrijas',
        features: selectedItem.geoms,
        styles: urbumuAtradnesPolyStyles,
        tooltipFunc: (feat) => `${feat.get('horizonts') || ''}; ${feat.get('aizsargjoslas_veids')} - ${aizsargjoslasVeidsDzerUdens[feat.get('aizsargjoslas_veids')]?.nos}; ${feat.get('piezimes')}`,
        legend: urbumuAtradnesLegend,
        legendStyle: urbumuAtradnesUrbumiStyle.default,
        zoomToLayer: true
      },
      urbumi: {
        title: 'Urbumi',
        features: selectedItem.urbumi,
        styles: urbumuAtradnesUrbumiStyle,
        tooltipFunc: (feat) => `${feat.get('id')}: ${feat.get('urb_nr_pirmavota') ? feat.get('urb_nr_pirmavota') : ''} ${feat.get('urb_adrese') ? feat.get('urb_adrese') : ''}`,
        selected: selectedUrbums,
        legend: urbumuAtradnesLegend
      }
    }

    const largeScreen = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) > 900

    return (
      <SplitterLayout
        key={largeScreen ? 'hor' : 'ver'}
        vertical={!largeScreen}
        customClassName="pane-paddings-hor"
        percentage
        primaryIndex={0}
        secondaryInitialSize={largeScreen ? gui.urbumu_atradne_kartina_karte_width : gui.urbumu_atradne_kartina_karte_height}
        onSecondaryPaneSizeChange={largeScreen ? this.mapPaneSizeChange : this.mapPaneSizeChangeHor}>
        <div className={'form-pane-scrollable' + (largeScreen ? '' : ' topside')}>
          <Form
            editable={false}
            dataObj={selectedItem}
            formFieldCfgs={this.formFieldCfgs}
            metadataFormCfg="urbumi_atradnes_view"
          />
          <h4>Akceptētie krājumi</h4>
          <div className="react-bootstrap-table">
            <table className="table table-hover table-bordered table-sm">
              <tbody>
                <tr>
                  <td className="table-primary bold text-right">Pazemes ūdens objekts</td>
                  {akceptetieKrajumi.map((item, idx) => (
                    <td key={`puo-${idx}`} className="text-center">{item.pazemes_udens_objekts}</td>
                  ))}
                </tr>
                <tr>
                  <td className="table-primary bold text-right">Ūdens horizonts</td>
                  {akceptetieKrajumi.map((item, idx) => (
                    <td key={`udens_nesejslanis-${idx}`} className="text-center">{item.udens_nesejslanis}</td>
                  ))}
                </tr>
                <tr>
                  <td className="table-primary bold text-right">Krājumu akceptēšanas datums</td>
                  {akceptetieKrajumi.map((item, idx) => (
                    <td key={`krajumu_akceptesanas_datums-${idx}`} className="text-center">{item.krajumu_akceptesanas_datums ? format(item.krajumu_akceptesanas_datums, 'dd.MM.yyyy') : '-'}</td>
                  ))}
                </tr>
                <tr>
                  <td className="table-primary bold text-right">Kategorija A</td>
                  {akceptetieKrajumi.map((item, idx) => (
                    <td key={`a-${idx}`} className="text-center">{item.kat_a}</td>
                  ))}
                </tr>
                <tr>
                  <td className="table-primary bold text-right">Kategorija N</td>
                  {akceptetieKrajumi.map((item, idx) => (
                    <td key={`n-${idx}`} className="text-center">{item.kat_n}</td>
                  ))}
                </tr>
                <tr>
                  <td className="table-primary bold text-right">Kategorija P</td>
                  {akceptetieKrajumi.map((item, idx) => (
                    <td key={`p-${idx}`} className="text-center">{item.kat_p}</td>
                  ))}
                </tr>
                {[
                  ["Iezis", "iezis"],
                  ["Ūdens ieguves shēma", "udens_ieguves_shema"],
                  ["Urbumu skaits", "urbumu_skaits"],
                  ["Ekspluatējamais intervāls (m)", "ekspluatejamais_intervals"],
                  ["Urbumu debits (m³/dnn)", "urbuma_debits"],
                  ["Līmenis (m)", "limenis"]
                ].map(([label, key]) => (
                  <tr key={key}>
                    <td className="table-primary bold text-right">{label}</td>
                    {akceptetieKrajumi.map((item, idx) => (
                      <td className="text-center" key={idx}>{item[key]}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <h4>Pazemes ūdeņu atradnes aizsargjoslas</h4>
          <div>
            {this.pazemesUdenuAtradnesAizsargjoslasColumns?.length > 0 && <BootstrapTable
              bootstrap4
              hover
              condensed
              keyField="id"
              data={pazemesUdenuAtradnesAizsargjoslas}
              columns={this.pazemesUdenuAtradnesAizsargjoslasColumns}
            />}
          </div>
          <h4>Atradnes urbumi</h4>
          <div>
            <BootstrapTable
              bootstrap4
              striped
              hover
              condensed
              keyField="table_row_key"
              data={selectedItem.urbumi}
              columns={this.atradnesUrbumiColumns}
              selectRow={{
                mode: 'radio',
                clickToSelect: true,
                hideSelectColumn: true,
                classes: 'selection-row',
                onSelect: this.handleOnSelect,
                selected: selectedUrbums ? [selectedUrbums] : []
              }}
            />
          </div>
        </div>
        <div className="rightside">
          <div className="karte-wrapper">
            <IzraktenisMap mapId="urbumu_atradne_kartina" vectorLayerCfgs={vectorLayerCfg} />
          </div>
        </div>
      </SplitterLayout>
    )
  }
}

const mapStateToProps = ({ urbumu_atradne, kodif, gui }) => ({ urbumu_atradne, kodif, gui })
export default connect(mapStateToProps, { ...urbumuAtradnesActions, guiSet, urbumuAtradneUrbumsSelected })(UrbumaAtradne)
